export default __webpack_public_path__ + "static/media/Group37964.e0187d71.png";